import { useState, useCallback } from "react";
import { toast } from "sonner";
import { createOwnerDashboardApi } from "../services/ownerDashboardApi";

const ownerApi = createOwnerDashboardApi();

export const useOwnerDashboard = ({
  fetchPendingSales,
  fetchUserProperties,
}) => {
  const [showConfirmSaleModal, setShowConfirmSaleModal] = useState(false);
  const [selectedSaleNotification, setSelectedSaleNotification] =
    useState(null);
  const [saleConfirmation, setSaleConfirmation] = useState({
    sale_price: "",
    notes: "",
  });

  const confirmSale = useCallback(async () => {
    if (!selectedSaleNotification) return;
    try {
      const r = await ownerApi.confirmSale(
        selectedSaleNotification.id,
        saleConfirmation,
      );
      if (r.ok) {
        toast.success("Venta confirmada!");
        setShowConfirmSaleModal(false);
        setSelectedSaleNotification(null);
        setSaleConfirmation({ sale_price: "", notes: "" });
        fetchPendingSales();
        fetchUserProperties();
      } else {
        const e = await r.json();
        toast.error(e.detail || "Error");
      }
    } catch (e) {
      toast.error("Error");
    }
  }, [
    selectedSaleNotification,
    saleConfirmation,
    fetchPendingSales,
    fetchUserProperties,
  ]);

  const rejectSale = useCallback(
    async (id, reason = "") => {
      try {
        const r = await ownerApi.rejectSale(id, reason);
        if (!r.ok) {
          const e = await r.json().catch(() => ({}));
          throw new Error(e.detail || "Error al rechazar");
        }
        toast.success("Notificacion rechazada");
        fetchPendingSales();
      } catch (e) {
        toast.error(e.message);
      }
    },
    [fetchPendingSales],
  );

  return {
    showConfirmSaleModal,
    setShowConfirmSaleModal,
    selectedSaleNotification,
    setSelectedSaleNotification,
    saleConfirmation,
    setSaleConfirmation,
    confirmSale,
    rejectSale,
  };
};
